/* global AdapterOrder */
'use strict';

/**
 * Order Helper
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdOrderHelper for ES6 usage
 *          7.2.0 #449 Refactor wdOrder to wdOrderService
 *          5.4.0 #328 Add adapter for order fulfillment statuses
 *
 * @author Deitric Jang <djang@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com> 
 *
 * @copyright (c) 2016-2020 Build Centrix
 */

var wdOrderHelper = angular.module('wd.helper.order', [])
    .factory(
    'wdOrderHelper',
    [
        'wdOauth2HttpService', 'wdSharedFunctionsService', 'wdStatusService', 'wdFulfillmentGroupService',
        function (wdOauth2HttpService, wdSharedFunctionsService, wdStatusService, wdFulfillmentGroupService)
        {
            var resource;

            resource = new AdapterOrder(wdOauth2HttpService, wdSharedFunctionsService, wdStatusService, wdFulfillmentGroupService);

            return resource;
        }
    ]);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdOrderHelper;
}  
// EOF